import { Text, Link, ArrowRightIcon } from '@cash-me/react-components'

import { ItemType } from 'modules/help'
import { pushDataLayer } from 'utils/push-data-layer'

const handleClickContact = () => {
  pushDataLayer({
    category: 'Clique',
    action: 'Botões',
    label: 'Accordeon Pergunta: Quais os custos da Portabilidade de Dívidas? - Fale Conosco'
  })

  location.href = 'http://www.cashme.com.br/fale-conosco'
}

export const accordion = [
  {
    id: 'faq-0',
    title: 'Como fazer o pedido de Portabilidade de Dívidas online?',
    item: [
      {
        id: 'faq-0-1',
        type: 'text' as ItemType,
        content: `Para solicitar a Portabilidade de Dívidas pelo site da CashMe, basta preencher o 
        formulário de simulação por completo, com os seguintes tópicos:`
      },
      {
        id: 'faq-0-2',
        type: 'checklist' as ItemType,
        content: [
          {
            id: 'faq-0-2-1',
            text: 'Valor de crédito desejado (acima de R$ 50 mil), valor do seu imóvel e número de parcelas;'
          },
          {
            id: 'faq-0-2-2',
            text: 'Dados pessoais;'
          },
          {
            id: 'faq-0-2-3',
            text: 'Dados do imóvel a ser colocado em garantia;'
          },
          {
            id: 'faq-0-2-4',
            text: 'Seu objetivo com o empréstimo.'
          }
        ]
      }
    ]
  },
  {
    id: 'faq-1',
    title: 'O Score influencia na aprovação da Portabilidade de Dívidas?',
    item: [
      {
        id: 'faq-1-1',
        type: 'text' as ItemType,
        content:
          'Sim. Mas outros pontos também são avaliados. Um bom Score dá mais segurança à instituição financeira na hora de analisar seu crédito e decidir se deve ou não ceder o dinheiro. Porém, outro pontos também são avaliados, como valor de bens ou renda fixa.'
      },
      {
        id: 'faq-1-2',
        type: 'link' as ItemType,
        content: {
          label: 'Simule agora',
          dataLayer: {
            category: 'Clique',
            action: 'Botões',
            label: 'Accordeon Pergunta: O Score influencia na aprovação do empréstimo para negativado - Simule agora'
          },
          href: 'simulador-home-equity',
          icon: ArrowRightIcon
        }
      }
    ]
  },
  {
    id: 'faq-2',
    title: 'Qual é a taxa de juros?',
    item: [
      {
        id: 'faq-2-1',
        type: 'text' as ItemType,
        content: 'Na CashMe, a taxa está sujeitra à análise.'
      }
    ]
  },
  {
    id: 'faq-3',
    title: 'Onde consultar se meu nome está negativado?',
    item: [
      {
        id: 'faq-3-1',
        type: 'text' as ItemType,
        content:
          'Você pode consultar o status do seu nome e CPF em sites da Serasa e do SPC ou presencialmente em ambos os órgãos, apresentando um documento oficial com foto.'
      },
      {
        id: 'faq-3-2',
        type: 'text' as ItemType,
        content: 'O SPC, no entanto, cobra uma taxa de R$ 16,90'
      }
    ]
  },
  {
    id: 'faq-4',
    title: 'Quais os custos da Portabilidade de Dívidas?',
    item: [
      {
        id: 'faq-4-1',
        type: 'node' as ItemType,
        content: (
          <Text size="body2" color="var(--colors-neutral-text-weak)">
            As condições estão sujeitas à análise. Entre em contato com a gente{' '}
            <Link onClick={handleClickContact} size="default">
              <Text as="span" size="body2" color="var(--colors-blue-text-default)">
                aqui
              </Text>
            </Link>
            .
          </Text>
        )
      },
      {
        id: 'faq-4-2',
        type: 'text' as ItemType,
        content:
          'Atenção: a CashMe não cobra depósito, taxa de avalista, taxa para negativado ou qualquer outro tipo de pagamento antecipado.'
      }
    ]
  }
]
